import { DISCOUNT_REGEX } from 'shared/utils/regex';
import { DiscountMode, DiscountSetting } from 'widgets/DiscountFormDrawer/model/types';

export const parseDiscounts = (data: string[]): DiscountSetting[] => {
  return data.map((entry) => {
    const match = entry.match(DISCOUNT_REGEX);

    if (!match) {
      return { period: '', value: '', type: '%', mode: DiscountMode.CUSTOM };
    }

    const [, period, value, percent] = match;

    const mode =
      period === DiscountMode.MIN_RENTAL_DURATION
        ? DiscountMode.MIN_RENTAL_DURATION
        : period === DiscountMode.ENTIRE_PERIOD
        ? DiscountMode.ENTIRE_PERIOD
        : DiscountMode.CUSTOM;

    return {
      period,
      value,
      type: percent === '%' ? '%' : '-',
      mode,
    };
  });
};
